<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">智慧图书馆</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <img src="../../assets/images/zhihui-1.png">
        <img src="../../assets/images/zhihui-2.png">
        <div class="threediv">
          产品介绍
        </div>
        <div class="threediv">
          移动图书馆采用42寸高分辨率触控屏作为触控终端，专程为图书馆管理人员及读者定制开发的一套图书馆私有云系统，通过该系统图书馆管理人员可有效高效的将图书馆资源和相关服务整合管理起来。
        </div>
        <div class="threediv">
          电子屏配置如下：
        </div>
        <div class="threediv">
          屏幕大小：42英寸
        </div>
        <div class="threediv">
          处理器：Intel 双核 2.3GHz
        </div>
        <div class="threediv">
          内存：4G
        </div>
        <div class="threediv">
          触控：支持多点触控
        </div>
        <div class="threediv">
          产品目标
        </div>
        <div class="threediv">
          实现个人用户与“云端资源”的在数字图书、有声图书资源上的互通和互联，让学生体验真正的“随时随地读书，随时随地下载”，有效利用现有数字资源。
        </div>
        <div class="threediv">
          产品特色
        </div>
        <div class="threediv">
          产品内置的云平台系统，一方面是图书馆的私有云系统，可以整合图书馆特有的自有资源和服务；另一方面本着开放、多元的设计理念，对外开放大部分接口。图书馆和第三方开发者都可以基于此平台，设计和开发更多针对图书馆的应用。对于这些第三方开发者的应用，图书馆管理人员可以自行审核、上线。
        </div>
        <div class="threediv">
          产品内置的云平台系统，一方面是图书馆的私有云系统，可以整合图书馆特有的自有资源和服务；另一方面本着开放、多元的设计理念，对外开放大部分接口。图书馆和第三方开发者都可以基于此平台，设计和开发更多针对图书馆的应用。对于这些第三方开发者的应用，图书馆管理人员可以自行审核、上线。
        </div>
        <div class="threediv">
          产品支持触摸电子屏、手机APP、微信网页和PC电脑。如电子书阅读模块，读者可以在电子屏浏览，发现好书后使用手机微信或APP扫码带走，随时随地阅读。“云”+“端”的软硬件结合服务模式打破了原来数字出版服务看不见摸不着的局限，让每一位读者能触摸、能体验、能感受、能下载，提供优异的数字阅读体验。
        </div>
        <div class="twodiv">
          瀑布流
        </div>
        <img src="../../assets/images/zhihui-3.png">
        <div class="threediv">
          1    产品概述
        </div>
        <div class="threediv">
          1.1    需求背景
        </div>
        <div class="threediv">
          电子屏的使用固定的一个书单列表，目前我们需要对其进行一套可以实现交互的方式，后台管理员可以对其进行配置，手动设置主题与书单列表。
        </div>
        <div class="threediv">
          1.2    产品概要
        </div>
        <div class="threediv">
          1.2.1     阅读方式
        </div>
        <div class="threediv">
          书籍从上方以瀑布流的形式不停的流动，给人一种视觉冲击，读者可以点击瀑布流的书籍扫一扫在线阅读电子书
        </div>
        <div class="threediv">
          1.2.2     动态皮肤
        </div>
        <div class="threediv">
          管理员通过后台系统可以动态切换瀑布流的背景图片，与书籍主题进行搭配，让书籍主题与封面相互搭配
        </div>
        <div class="threediv">
          1.2.3     定制书籍主题
        </div>
        <div class="threediv">
          后台系统管理员灵活控制某一电子屏的书籍信息，可以根据实际的情况动态灵活修改电子书展示书籍信息
        </div>
        <div class="threediv">
          1.3     产品服务
        </div>
        <div class="threediv">
          1.3.1     海量电子书
        </div>
        <div class="threediv">
          目前已经拥有12W电子资源，同时保持每小时10本新书的更新量
        </div>
        <div class="threediv">
          1.3.2     正版授权
        </div>
        <div class="threediv">
          所有电子书都具有合法的正版版权
        </div>
        <div class="threediv"
          >1.3.3     离线阅读
        </div>
        <div class="threediv">
          用户扫描离线下载书籍，可以随时随地阅读自己收藏的电子书书籍   
        </div>
        <img src="../../assets/images/zhihui-4.png">
        <img src="../../assets/images/zhihui-5.png">
        <div class="twodiv">
          门禁
        </div>
        <div class="threediv">
          用户扫描离线下载书籍，可以随时随地阅读自己收藏的电子书书籍   
        </div>
        <div>
          图书馆通道管理系统是图书馆智能化管理的重要分支，它可分为流通，查询，信息共享等很多方面。
        </div>
        <div>
          图书馆通道管理系统采用集中控制的方式，前端设备包括入口通道闸机、读卡器、视频监控等，设备通过网络连接于主控电脑，实现数据的实时采集。主控电脑能够设置工作模式、设置用卡权限、储存验卡记录，同时管理软件将每个门禁通道的进入情况统计汇总，按要求查询、打印统计报表。\
        </div>
        <div>
          功能介绍：
        </div>
        <div class="threediv">
          1、身份识别
        </div>
        <div>
          系统能够准确识别持卡人身份，确定其是否有通过的权限，持卡人在闸机上刷卡验证有效后，闸机闸门打开通行，否则禁止通行。
        </div>
        <div class="threediv">
          2、报警功能
        </div>
        <div>
          外来人员或其他无权限人员通过通道时，通道会发出声光报警，提示管理人员，同时抓拍影像资料。
        </div>
        <div class="threediv">
          3、参数设置
        </div>
        <div>
          图书馆通道管理系统能进行灵活的参数设置和运行模式设置，如有效卡的通过时间、正常模式、免检模式、紧急通行模式等。
        </div>
        <div class="threediv">
          4、信息统计
        </div>
        <div>
          系统与图书馆局域网连接，记录每次通行信息且可按照读者类别、部门、通行日期、时间等各种属性形成统计报表。
        </div>
        <div class="threediv">
          5、拓展功能
        </div>
        <div class="threediv">
          系统闸机主控模块采用开放式技术，内含CPU、内存、显示芯片、多路输入、输出端口、串口、打印机接口等，能够轻松实现功能增加与软件升级。系统扩展性好，能够实现与校园一卡通对接。
        </div>
        <div class="twodiv">
          自助借还机
        </div>
        <img src="../../assets/images/zhihui-6.png">
        <div class="threediv">
          自助借还书系统是智慧图书馆的重要组成部分，它的终端设备为自助借还书机。自助借还书系统通过对粘贴有电子标签或条形码的资料、书籍进行扫描、识别，将其信息反馈到系统中进行处理，自动完成借阅与退还。自助借还书机的操作界面简洁，方便用户使用，而且其硬件设备安全可靠。
        </div>
        <div class="threediv">
          功能特点：
        </div>
        <div class="threediv">
          1、自动借还书机具备自助借书、还书、续借和超期查询等功能；
        </div>
        <div class="threediv">
          2、操作界面伴有语音和文字提示，简洁直观、操作简单；
        </div>
        <div class="threediv">
          3、还书机内置还书箱，方便用户放置图书；
        </div>
        <div class="threediv">
          4、系统采用视频多书侦测技术，不受磁条和书籍摆放位置的影响，防止一码多借的错误；
        </div>
        <div class="threediv">
          5、具有两个以上的红外感应器，防止借阅时书籍被抽换；
        </div>
        <div class="threediv">
          6、具有视频管理功能，系统能够抓拍读者借还书过程，将证件号码、时间等信息叠加到图像上；
        </div>
        <div class="threediv">
          7、采用标准数据接口，能够对接主流图书馆管理系统；
        </div>
        <div class="threediv">
          8、系统支持条形码、一卡通等多种借阅方式；
        </div>
        <div class="threediv">
          9、系统提供远程异常报警功能，以短信等方式将异常情况通知管理员；
        </div>
        <div class="threediv">
          10、支持远程查看、控制和管理设备运行；
        </div>
        <div class="threediv">
          11、支持WEB查询统计，可以生成报表或者图表；
        </div>
        <div class="threediv">
          12、实时打印借还书凭证。
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 进入直播
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }

  img {
    max-width: 100%;
    max-height: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Zhihui.vue